import { GetSideMetricsAsyncEvents } from '@bufferController/BufferMetrics/helpers/GetSideMetricsAsync.events';
import { TEventBus } from '@eventBus/EventBus';

export const getTargetBuffer: (eventBus: TEventBus) => Promise<number> = (eventBus) =>
  new Promise((resolve) => {
    eventBus.publish(GetSideMetricsAsyncEvents.getPlaybackSpeedControllerMetrics, {});
    eventBus.subscribeOnce(GetSideMetricsAsyncEvents.playbackSpeedControllerMetricsAvailable, (targetBuffer: number) => {
      resolve(targetBuffer);
    });
  });

export const getPlayingTimeFraction: (eventBus: TEventBus) => Promise<number | null> = (eventBus) =>
  new Promise((resolve) => {
    eventBus.publish(GetSideMetricsAsyncEvents.getPlayingTimeFraction, {});
    eventBus.subscribeOnce(GetSideMetricsAsyncEvents.getPlayingTimeFractionAvailable, (playingTimeFraction: number) => {
      resolve(playingTimeFraction);
    });
  });
